import React, { useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { Dialog } from '../../../components';
import Text from '../../../components/Text';
import { Checkbox } from '../../DutyAssign/components/Attendance/Setting';

const AvailableFilterPopup = ({ availableFilterList, handleClose, handleUpdate }) => {
  const classes = useStyles();
  const [data, setData] = useState([...availableFilterList]);
  let checkedLength = _.filter(data, { checked: true }).length;
  console.log('data', data);

  // 计算总选项数量（包括主项和子项）
  const totalItems = data.reduce((count, item) => {
    // 计算主项
    const mainItems = 1;

    // 计算子项
    const subItems = item.satelliteStores ? item.satelliteStores.length : 0;

    return count + mainItems + subItems;
  }, 0);

  const satelliteStoresCheckedLength = data.reduce((total, item) => {
    if (item.satelliteStores && item.satelliteStores.length > 0) {
      const checkedCount = _.filter(item.satelliteStores, { checked: true }).length;
      return total + checkedCount;
    }
    return total;
  }, 0);

  checkedLength = checkedLength + satelliteStoresCheckedLength;
  const handleSelectAll = () => {
    setData((prevData) => {
      return prevData.map((item) => ({
        ...item,
        checked: true,
        ...(item.satelliteStores && {
          satelliteStores: item.satelliteStores.map((store) => ({
            ...store,
            checked: true,
          })),
        }),
      }));
    });
  };

  const handleCancelAll = () => {
    setData((prevData) => {
      return prevData.map((item) => ({
        ...item,
        checked: false,
        ...(item.satelliteStores && {
          satelliteStores: item.satelliteStores.map((store) => ({
            ...store,
            checked: false,
          })),
        }),
      }));
    });
  };

  const handleSelectItem = (id) => () => {
    setData((prevData) => {
      return prevData.map((item) => ({
        ...item,
        checked: item.id === id ? !item.checked : item.checked,
        ...(item.satelliteStores && {
          satelliteStores: item.satelliteStores.map((store) => ({
            ...store,
          })),
        }),
      }));
    });
  };

  // 添加处理子项选择的方法
  const handleSelectSubItem = (id, satelliteStoreId) => {
    setData((prevData) => {
      return prevData.map((item) => ({
        ...item,
        ...(item.satelliteStores && {
          satelliteStores: item.satelliteStores.map((satelliteStoreItem) => ({
            ...satelliteStoreItem,
            checked:
              item.id === id && satelliteStoreItem.id === satelliteStoreId
                ? !satelliteStoreItem.checked
                : satelliteStoreItem.checked,
          })),
        }),
      }));
    });
  };

  const handleConfirm = () => {
    handleUpdate(data);
  };

  return (
    <Dialog
      open={true}
      title="Filter"
      confirm="Update"
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      dialogfootStyle={{ marginTop: '1rem' }}
      dialogheadStyle={{ padding: '0 1.563rem', marginBottom: '0.5rem' }}
      dialogRootStyle={{ paddingLeft: '0', paddingRight: '0' }}
      confirmStyle={{ backgroundColor: '#28D2AB' }}
    >
      <Box className={classes.container}>
        {data.map((item, index) => (
          <React.Fragment key={item.id}>
            {/* 渲染主项 */}
            <Box
              className={classes.mainItemContainer}
              style={{ backgroundColor: index % 2 === 1 ? '#F6F6F6' : 'none' }}
            >
              <Text fontSize="1rem" color="#2E4469" style={{ whiteSpace: 'pre' }}>
                {item.title}
              </Text>
              <Checkbox check={item.checked} handleChange={handleSelectItem(item.id)} />
            </Box>
            {/* 如果存在卫星存储项，则渲染子项 */}
            {item.satelliteStores && item.satelliteStores.length > 0 && (
              <Box>
                {item.satelliteStores.map((satelliteStoreItem, satelliteStoreIndex) => (
                  <Box
                    key={`${item.id}-${satelliteStoreItem.id}`}
                    className={classes.satelliteStoresContainer}
                    style={{ backgroundColor: (index + satelliteStoreIndex) % 2 === 1 ? '#F6F6F6' : 'none' }}
                  >
                    <Text fontSize="1rem" color="#2E4469" style={{ whiteSpace: 'pre' }}>
                      {satelliteStoreItem.satelliteStoreName}
                    </Text>
                    <Checkbox
                      check={satelliteStoreItem.checked}
                      handleChange={() => {
                        handleSelectSubItem(item.id, satelliteStoreItem.id);
                      }}
                    />
                  </Box>
                ))}
              </Box>
            )}
          </React.Fragment>
        ))}
        <Box className={classes.selectAllContainer}>
          <Text fontSize="1rem" color="#2E4469">
            checked <span style={{ color: '#538FFF' }}>{checkedLength}</span>/{totalItems}
          </Text>
          <Box className={classes.selectBtnContainer}>
            <ButtonBase className={classes.selectBtn} onClick={handleSelectAll}>
              Select All
            </ButtonBase>
            |
            <ButtonBase className={classes.selectBtn} onClick={handleCancelAll}>
              Clean All
            </ButtonBase>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    maxHeight: '30rem',
  },
  mainItemContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '3rem',
    minHeight: '3rem',
    padding: '0 1.563rem',
    paddingRight: '2rem',
    fontWeight: 'bold', // 加粗字体以突出主项
    backgroundColor: '#F5FAFF', // 主项背景色
  },
  satelliteStoresContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '3rem',
    minHeight: '3rem',
    padding: '0 1.563rem',
    paddingLeft: '2rem', // 子项左侧内边距
  },
  selectAllContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '3rem',
    minHeight: '3rem',
    backgroundColor: '#F5FAFF',
    padding: '0 1.563rem',
    paddingRight: '2rem',
    position: 'sticky',
    bottom: '0',
    borderBottom: '1px solid #E4E7EB',
    boxSizing: 'border-box',
  },
  selectBtnContainer: {
    display: 'flex',
    gap: '0.5rem',
    fontSize: '1rem',
    color: '#1973E6',
  },
  selectBtn: {
    fontSize: '1rem',
    color: '#1973E6',
    fontFamily: 'NotoSans-Medium',
  },
}));

export default AvailableFilterPopup;
